<section class="home">
  <mat-carousel
    timings="150ms ease-in"
    [autoplay]="true"
    interval="3000"
    color="accent"
    slides="numberImagesSlide"
    [loop]="true"
    [hideArrows]="false"
    [hideIndicators]="true"
    [useKeyboard]="true"
    [useMouseWheel]="false"
    orientation="ltr"
    *ngIf="slides?.length > 0"
    [maintainAspectRatio]="false"
    [slideHeight]="remainingHeight ? remainingHeight + 'px' : 250 + 'px'"
    (click)="testClick()"
    (change)="onChange($event)"
  >
    <!-- [proportion]="setProportion()" -->
    <mat-carousel-slide
      #matCarouselSlide
      *ngFor="let slide of slides; let i = index"
      [image]="slide.foto"
      overlayColor="#00000040"
      [hideOverlay]="false"
    >
      <div
        style="
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        "
      >
        <!-- <h1 class="text-white title"><strong>Afíliate</strong></h1> -->
      </div>
    </mat-carousel-slide>
  </mat-carousel>
</section>
